import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import LanguageDropdown from 'components/common/language-dropdown';
import useTranslation from 'customHooks/translate';
import { getAccountData } from 'services/accounts';
import { ACCOUNT_INFO } from 'events/types';

import MobileMenu from './MobileMenu';
import { titleLinks } from './titles';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const translation = useTranslation();
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const location = useLocation();

  const links = titleLinks(translation);
  const currentLink = links?.find((link) =>
    location.pathname.startsWith(link?.url)
  );

  const accountInfoQuery = useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: getAccountData,
    select: (response) => response.data.data,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0,
  });

  const accountData = accountInfoQuery.data;

  useEffect(() => {
    if (!accountData) {
      accountInfoQuery.refetch();
    }
  }, [accountData]);

  return (
    <div className="relative flex h-[81px] w-full items-center justify-between gap-[10px] border-b border-b-[#f5f7f9] px-[16px] py-[14px] md:px-[32px] md:py-[16px]">
      <div className="hidden items-center gap-[12px] md:flex">
        {currentLink && (
          <>
            <img
              className="h-[20px] w-[20px]"
              src={`assets/dashboard-icon.svg`}
              alt=""
            />
            <p className="text-[16px] font-semibold text-[#1D1D1D]">
              {currentLink?.name}
            </p>
          </>
        )}
      </div>
      <Link to="/dashboard" className="md:hidden">
        <img className="h-[30px] w-[90px]" src="assets/logo.png" alt="logo" />
      </Link>
      <div className="flex items-center">
        <div className="hidden items-center gap-[8px] md:flex">
          <Link to="/invoices/new" state={{ from: 'debitor' }}>
            <button className="flex items-center gap-[6px] rounded-[10px] border-2 border-[#6DCD90] px-[20px] py-[12px] text-[14px] font-medium text-[#1D1D1D] transition-all duration-300 ease-in-out hover:bg-gray-100">
              <img
                src="/assets/new-invoice.svg"
                alt="icon"
                className="h-5 w-5"
              />
              <span className="hidden lg:block">
                {translation.create.InvoiceButton}
              </span>
            </button>
          </Link>
          <Link to="/cost/new" state={{ from: 'creditor' }}>
            <button className="flex items-center gap-[6px] rounded-[10px] border-2 border-[#466AFB] px-[20px] py-[12px] text-[14px] font-medium text-[#1D1D1D] transition-all duration-300 ease-in-out hover:bg-gray-100">
              <img src="/assets/new-cost.svg" alt="icon" className="h-5 w-5" />
              <span className="hidden lg:block">
                {translation.create.CostButton}
              </span>
            </button>
          </Link>
        </div>
        <div className="ml-[0px] mr-[8px] md:ml-[8px] md:mr-[0px]">
          <LanguageDropdown />
        </div>
        <div
          onClick={toggleMenu}
          className="flex h-[38px] w-[38px] flex-col items-center justify-center gap-[4px] rounded-[50%] bg-[#466AFB0A] p-[10px] md:hidden"
        >
          <span className="h-[1.5px] w-full rounded-[2px] bg-[#292D32]" />
          <span className="h-[1.5px] w-full rounded-[2px] bg-[#292D32]" />
          <span className="h-[1.5px] w-full rounded-[2px] bg-[#292D32]" />
        </div>
      </div>
      <MobileMenu
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        currentAccountData={accountData}
      />
    </div>
  );
};

export default Header;
